import { Box, Flex, Stack } from "@chakra-ui/react";
import CustomerLinks from "components/sidebar/components/CustomerLinks";
import SidebarBanner from "components/sidebar/components/SidebarBanner";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "store/user/selector";
import { clearDraftStorage } from "views/customer/order/utils/draftStorage";

function CustomerSidebarContent(props: {
  routes: RoutesType[];
  onMenuItemClicked?: Function;
}) {
  const { routes, onMenuItemClicked } = props;

  const navigate = useNavigate();
  const user = useSelector(userSelector);

  const onPlaceOrder = () => {
    clearDraftStorage(user?.user_id);
    navigate("/customer/main");
  };
  
  return (
    <Flex direction="column">
      <Stack direction="column">
        <Box
          pl="8px"
          sx={{
            a: {
              "&.active": {
                p: {
                  fontWeight: 600,
                },
              },
            },
          }}
        >
          <CustomerLinks routes={routes} onMenuItemClicked={onMenuItemClicked} />
        </Box>
      </Stack>
      
      <SidebarBanner onStartOrder={onPlaceOrder} />
    </Flex>
  );
}

export default CustomerSidebarContent;
